<template>
  <div id="sidebars-customizer">
    <div class="vx-row mt-3">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li>
            <router-link to="/businessEntity/" class="vx-row">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
              <h3>{{ $t("entity.label.view_business_entity") }}</h3>
            </router-link>
          </li>
          <li></li>
        </ul>
      </div>
    </div>
    <div id="user-data parentx-demo-2 " v-if="entityId && entityDetail">
      <div class="vx-row mb-base">
        <div class="vx-card pl-6 pr-6" style="min-height: 643px">
          <div class="vx-row p-3 sm-flex-direction">
            <div class="vx-col w-full md:w-full lg:w-full">
              <div class="nav-heading mt-3">
                {{ navigationSelection }}
              </div>
              <ul class="horizontal-sm-btn flex mb-2 float-right">
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-plus"
                      class="truncate"
                      type="border"
                      @click="handleAddTicket"
                      size="small"
                      >{{ $t("entity.label.add_ticket") }}</vs-button
                    >
                  </div>
                </li>
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-dollar-sign"
                      class="truncate"
                      type="border"
                      @click="handleCreatePayment"
                      size="small"
                      >{{ $t("entity.label.payments") }}</vs-button
                    >
                  </div>
                </li>
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-sliders"
                      type="border"
                      class="truncate"
                      @click="handleAdjustments"
                      size="small"
                      >{{ $t("entity.label.adjustments") }}</vs-button
                    >
                  </div>
                </li>
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      class="truncate"
                      icon-pack="feather"
                      icon="icon-plus"
                      type="border"
                      @click="handleAgreement"
                      size="small"
                      >{{ $t("entity.label.agreements") }}</vs-button
                    >
                  </div>
                </li>
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-plus"
                      class="truncate"
                      type="border"
                      @click="additionalInfo = true"
                      size="small"
                      >{{ $t("entity.label.charges") }}</vs-button
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/5 w-full">
              <div class="about-detail">
                <div class="center pt-6" style="position: relative">
                  <img
                    src="@/assets/images/avatar/avatar.png"
                    id="avatar-col"
                    class="rounded avatar-pic"
                  />
                  <vs-button
                    icon-pack="feather"
                    icon="icon-edit-2"
                    size="small"
                    title="Edit"
                    @click="editEntity(entityId)"
                    class="edit-btn"
                  ></vs-button>
                </div>
                <div
                  class="center"
                  style="
                    font-weight: 600;
                    font-size: 16px;
                    padding: 5px;
                    color: #000000;
                  "
                >
                  {{ entityDetail.name }}
                </div>

                <div class="p-1">
                  <table>
                    <tr>
                      <td class="vx-col light-label">
                        {{ $t("entity.label.parent_business_entity") }}: &nbsp;
                      </td>
                      <td class="vx-col dark-label">
                        {{ entityDetail.parentName }}
                      </td>
                    </tr>
                    <tr>
                      <td class="vx-col light-label">
                        {{ $t("entity.label.relationship_type") }}: &nbsp;
                      </td>
                      <td class="vx-col dark-label">
                        {{ entityDetail.businessType }}
                      </td>
                    </tr>
                    <tr>
                      <td class="vx-col light-label">
                        {{ $t("entity.label.balance") }}: &nbsp;
                      </td>
                      <td class="vx-col dark-label">
                        {{ entityDetail.balance }}
                      </td>
                    </tr>
                    <tr>
                      <td class="vx-col light-label">
                        {{ $t("entity.label.credit_limit") }}: &nbsp;
                      </td>
                      <td class="vx-col dark-label">
                        {{ entityDetail.credit }}
                      </td>
                    </tr>
                  </table>

                  <div class="vx-row p-1">
                    <div class="vx-col md:w-1/2 w-full light-label pl-4"></div>
                    <div class="vx-col md:w-1/2 w-full dark-label"></div>
                  </div>
                  <div class="vx-row p-1">
                    <div class="vx-col md:w-1/2 w-full light-label pl-4"></div>
                    <div class="vx-col md:w-1/2 w-full dark-label"></div>
                  </div>
                </div>
              </div>
              <div
                class="navigation-button-lay p-2"
                :class="[{ active: basicToggle }]"
              >
                <div
                  class="vx-row"
                  @click.stop="
                    togglePage(1);
                    basicTogggle = true;
                  "
                >
                  <div class="vx-col">
                    {{ tabNameShort($t("entity.label.business_entity_info")) }}
                  </div>
                  <div class="vx-col" style="margin-left: auto">
                    <span> <feather-icon icon="ChevronRightIcon" /></span>
                  </div>
                </div>
              </div>
              <div
                class="navigation-button-lay p-2"
                :class="[{ active: agreementToggle }]"
              >
                <div class="vx-row" @click.stop="togglePage(2)">
                  <div class="vx-col">
                    {{ tabNameShort($t("entity.label.agreement_details")) }}
                  </div>
                  <div class="vx-col" style="margin-left: auto">
                    <span> <feather-icon icon="ChevronRightIcon" /></span>
                  </div>
                </div>
              </div>
              <div
                class="navigation-button-lay p-2"
                :class="[{ active: TicketToggle }]"
                @click.stop="togglePage(3)"
              >
                <div class="vx-row">
                  <div class="vx-col">{{ $t("entity.label.tickets") }}</div>
                  <div class="vx-col" style="margin-left: auto">
                    <span> <feather-icon icon="ChevronRightIcon" /></span>
                  </div>
                </div>
              </div>
              <div
                class="navigation-button-lay p-2"
                :class="[{ active: disbursmentToggle }]"
                @click.stop="togglePage(4)"
              >
                <div class="vx-row">
                  <div class="vx-col">
                    {{
                      tabNameShort(
                        $t("entity.label.business_entity_disbursements")
                      )
                    }}
                  </div>
                  <div class="vx-col" style="margin-left: auto">
                    <span> <feather-icon icon="ChevronRightIcon" /></span>
                  </div>
                </div>
              </div>
              <div
                class="navigation-button-lay p-2"
                :class="[{ active: transactionToggle }]"
                @click.stop="togglePage(5)"
              >
                <div class="vx-row">
                  <div class="vx-col">
                    {{
                      tabNameShort($t("entity.label.financial_transactions"))
                    }}
                  </div>
                  <div class="vx-col" style="margin-left: auto">
                    <span> <feather-icon icon="ChevronRightIcon" /></span>
                  </div>
                </div>
              </div>
              <div
                class="navigation-button-lay p-2"
                :class="[{ active: customerToggle }]"
                @click.stop="togglePage(6)"
              >
                <div class="vx-row">
                  <div class="vx-col">{{ $t("entity.label.customers") }}</div>
                  <div class="vx-col" style="margin-left: auto">
                    <span> <feather-icon icon="ChevronRightIcon" /></span>
                  </div>
                </div>
              </div>
              <div
                class="navigation-button-lay p-2"
                :class="[{ active: settlementToggle }]"
                @click.stop="togglePage(7)"
              >
                <div class="vx-row">
                  <div class="vx-col">{{ $t("entity.label.settlement") }}</div>
                  <div class="vx-col" style="margin-left: auto">
                    <span> <feather-icon icon="ChevronRightIcon" /></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-4/5 w-full">
              <div class="details-layout p-2" v-if="basicToggle">
                <div class="vx-row">
                  <div class="vx-col md:w-1/2 w-full">
                    <vs-table stripe :data="entityDetail" class="details-table">
                      <template slot="header">
                        <div class="details-header w-full">
                          <div>{{ $t("entity.label.basic_information") }}</div>
                        </div>
                      </template>
                      <template>
                        <vs-tr>
                          <vs-td>{{
                            $t("entity.label.business_entity_code")
                          }}</vs-td>

                          <vs-td>{{ entityDetail.externalId }}</vs-td>
                        </vs-tr>
                        <vs-tr>
                          <vs-td>{{
                            $t("entity.label.business_entity_name")
                          }}</vs-td>

                          <vs-td>{{ entityDetail.name }}</vs-td>
                        </vs-tr>
                        <vs-tr>
                          <vs-td>{{
                            $t("entity.label.business_entity_type")
                          }}</vs-td>

                          <vs-td>{{ entityDetail.officeType }}</vs-td>
                        </vs-tr>
                        <vs-tr>
                          <vs-td>{{ $t("entity.label.opened_on") }}</vs-td>

                          <vs-td>{{ getDate(entityDetail.openingDate) }}</vs-td>
                        </vs-tr>
                        <vs-tr>
                          <vs-td>{{ $t("entity.label.contact_person") }}</vs-td>

                          <vs-td>{{ entityDetail.contactPerson }}</vs-td>
                        </vs-tr>
                        <vs-tr>
                          <vs-td>{{ $t("entity.label.email") }}</vs-td>

                          <vs-td>{{ entityDetail.email }}</vs-td>
                        </vs-tr>
                        <vs-tr>
                          <vs-td>{{ $t("entity.label.phone_number") }}</vs-td>

                          <vs-td>{{ entityDetail.phoneNumber }}</vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>
                  <div class="vx-col md:w-1/2 w-full">
                    <vs-table stripe :data="entityDetail" class="details-table">
                      <template slot="header">
                        <div class="details-header w-full">
                          <div>
                            {{ $t("entity.label.address_information") }}
                          </div>
                        </div>
                      </template>
                      <template>
                        <vs-tr>
                          <vs-td>{{ $t("entity.label.address_name") }}</vs-td>

                          <vs-td>{{ entityDetail.addressName }}</vs-td>
                        </vs-tr>
                        <vs-tr>
                          <vs-td>{{ $t("entity.label.city_area") }}</vs-td>

                          <vs-td>{{ entityDetail.city }}</vs-td>
                        </vs-tr>
                        <vs-tr>
                          <vs-td>{{ $t("entity.label.district") }}</vs-td>

                          <vs-td>{{ entityDetail.district }}</vs-td>
                        </vs-tr>
                        <vs-tr>
                          <vs-td>{{ $t("entity.label.state") }}</vs-td>

                          <vs-td>{{ entityDetail.state }}</vs-td>
                        </vs-tr>
                        <vs-tr>
                          <vs-td>{{ $t("entity.label.country") }}</vs-td>

                          <vs-td>{{ entityDetail.country }}</vs-td>
                        </vs-tr>
                        <vs-tr>
                          <vs-td>{{ $t("entity.label.zip_code") }}</vs-td>

                          <vs-td>{{ entityDetail.zip }}</vs-td>
                        </vs-tr>
                        <vs-tr>
                          <vs-td>{{ $t("entity.label.gst_reg_no") }}</vs-td>

                          <vs-td>{{ entityDetail.gstRegNo }}</vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>
                </div>
              </div>
              <div>
                <div class="vx-row" v-if="agreementToggle">
                  <div class="vx-col w-full">
                    <AgreementDetails :entityId="entityId" />
                  </div>
                </div>
                <div class="vx-row" v-if="TicketToggle">
                  <div class="vx-col w-full">
                    <Tickets :entityId="entityId" />
                  </div>
                </div>
                <div class="vx-row" v-if="disbursmentToggle">
                  <div class="vx-col w-full">
                    <Disbursements :entityName="entityDetail.name" />
                  </div>
                </div>
                <div class="vx-row" v-if="transactionToggle">
                  <div class="vx-col w-full">
                    <Transactions :entityId="entityId" />
                  </div>
                </div>
                <div class="vx-row" v-if="customerToggle">
                  <div class="vx-col w-full">
                    <Customers :entityId="entityId" />
                  </div>
                </div>
                <!-- <div class="vx-row" v-if="settlementToggle">
                  <div class="vx-col w-full">
                    <Settlement :entityId="entityId" />
                  </div>
                </div> -->
                <div class="details-layout p-2" v-if="settlementToggle">
                  <div class="vx-row">
                    <div class="vx-col md:w-1/2 w-full">
                      <vs-table
                        stripe
                        :data="entityDetail"
                        class="details-table"
                      >
                        <template slot="header">
                          <div class="details-header w-full">
                            <div>
                              {{ $t("entity.label.roaming_settlement") }}
                            </div>
                          </div>
                        </template>
                        <template>
                          <vs-tr>
                            <vs-td>{{
                              $t("entity.label.contract_agreement")
                            }}</vs-td>
                          </vs-tr>
                          <vs-tr>
                            <vs-td>{{
                              $t("entity.label.tariff_plan_agreement")
                            }}</vs-td>
                          </vs-tr>
                        </template>
                      </vs-table>
                    </div>
                    <div class="vx-col md:w-1/2 w-full">
                      <vs-table
                        stripe
                        :data="entityDetail"
                        class="details-table"
                      >
                        <template slot="header">
                          <div class="details-header w-full">
                            <div>
                              {{ $t("entity.label.interconnect_settlement") }}
                            </div>
                          </div>
                        </template>
                        <template>
                          <vs-tr>
                            <vs-td>{{
                              $t("entity.label.contract_agreement")
                            }}</vs-td>
                          </vs-tr>
                          <vs-tr>
                            <vs-td>{{
                              $t("entity.label.tariff_plan_agreement")
                            }}</vs-td>
                          </vs-tr>
                        </template>
                      </vs-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="centerx">
          <vs-popup
            classContent="popup-example"
            :title="$t('entity.label.new_ticket')"
            :active.sync="ticketPopup"
            class="popup-close"
          >
            <ValidationObserver ref="observer">
              <form>
                <div class="vx-row">
                  <div class="vx-col md:w-1/2 w-full">
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("entity.label.priority")
                        }}<span class="required"> *</span></small
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="priority"
                        :key="resetKey"
                      >
                        <v-select
                          label="value"
                          :options="ticketTemplates.priorityType"
                          placeholder="Select Priority"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          v-model="ticket.priority"
                          :reduce="(value) => value.value"
                          class="min-w-200 w-full mb-2"
                        />
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="vx-col md:w-1/2 w-full">
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="ticket date"
                      :key="resetKey"
                    >
                      <vs-input
                        :label="$t('entity.label.ticket_date')"
                        class="w-full font-semibold starlabel"
                        readonly
                        v-model="ticket.ticketDate"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full">
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("entity.label.category")
                        }}<span class="required"> *</span></small
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="category"
                        :key="resetKey"
                      >
                        <v-select
                          label="mCodeValue"
                          :options="ticketTemplates.problemsDatas"
                          placeholder="Select Category"
                          :reduce="(mCodeValue) => mCodeValue.id"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          v-model="ticket.problemCode"
                          class="min-w-200 w-full mb-2"
                        >
                          <template v-slot:option="option">{{
                            option.mCodeValue
                          }}</template>
                        </v-select>
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="vx-col md:w-1/2 w-full">
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("entity.label.sub_category")
                        }}<span class="required"> *</span></small
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="sub category"
                        :key="resetKey"
                      >
                        <v-select
                          label="subCategory"
                          :options="subCategoryItem"
                          placeholder="Select Sub Category"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          v-model="ticket.subCategory"
                          :reduce="(subCategory) => subCategory.subCategory"
                          class="min-w-200 w-full mb-2"
                        />
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="vx-col md:w-1/2 w-full">
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("entity.label.assign_to")
                        }}<span class="required"> *</span></small
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="assign to"
                        :key="resetKey"
                      >
                        <v-select
                          label="userName"
                          :options="ticketTemplates.usersData"
                          placeholder="--Select One--"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          v-model="ticket.assignedTo"
                          :reduce="(userName) => userName.id"
                          class="min-w-200 w-full mb-2"
                        />
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="vx-col md:w-1/2 w-full">
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("entity.label.source")
                        }}<span class="required"> *</span></small
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="source"
                        :key="resetKey"
                      >
                        <v-select
                          label="mCodeValue"
                          :options="ticketTemplates.sourceData"
                          placeholder="Select Source"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          class="min-w-200 w-full mb-2"
                          :reduce="(mCodeValue) => mCodeValue.mCodeValue"
                          v-model="ticket.sourceOfTicket"
                        />
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("entity.label.due_time")
                        }}<span class="required"> *</span></small
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="due time"
                        :key="resetKey"
                      >
                        <flat-pickr
                          :config="configdateTimePicker"
                          class="w-full"
                          v-model="ticket.dueTime"
                        />
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="title"
                      :key="resetKey"
                    >
                      <vs-input
                        :label="$t('entity.label.title')"
                        v-model="ticket.title"
                        class="w-full font-semibold mb-2 starlabel"
                        icon-no-border
                        :danger="false"
                        danger-text="wrong input"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("entity.label.description")
                        }}<span class="required"> *</span></small
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="description"
                        :key="resetKey"
                      >
                        <vs-textarea
                          class="w-full"
                          v-model="ticket.description"
                        />
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
                    <pick-file @fileUpdate="changeDocument" />
                  </div>
                </div>

                <div style="height: 30px"></div>
                <div class="center">
                  <span class="ml-1 mr-1">
                    <vs-button
                      @click="addTicket"
                      class="footerButton-next"
                      style="top: 0px"
                      >{{ $t("entity.label.submit") }}</vs-button
                    >
                  </span>
                </div>
                <div style="height: 20px"></div>
              </form>
            </ValidationObserver>
          </vs-popup>
        </div>
        <div class="centerx">
          <vs-popup
            classContent="popup-example"
            :title="$t('entity.label.create_new_ticket')"
            :active.sync="ticketPopupEdit"
            class="popup-close"
          >
            <form>
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("entity.label.priority")
                      }}<span class="required"> *</span></small
                    >
                    <v-select
                      label="value"
                      :options="ticketTemplates.priorityType"
                      placeholder="Select Priority"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      v-model="ticket.priority"
                      :reduce="(value) => value.value"
                      class="min-w-200 w-full mb-2"
                    />
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <vs-input
                    :label="$t('entity.label.ticket_date')"
                    class="w-full font-semibold starlabel"
                    readonly
                    v-model="ticket.ticketDate"
                  />
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("entity.label.category")
                      }}<span class="required"> *</span></small
                    >
                    <v-select
                      label="mCodeValue"
                      :options="ticketTemplates.problemsDatas"
                      placeholder="Select Category"
                      :reduce="(mCodeValue) => mCodeValue.id"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      v-model="ticket.problemCode"
                      class="min-w-200 w-full mb-2"
                    >
                      <template v-slot:option="option">{{
                        option.mCodeValue
                      }}</template>
                    </v-select>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("entity.label.subcategory")
                      }}<span class="required"> *</span></small
                    >
                    <v-select
                      label="subCategory"
                      :options="subCategoryItem"
                      placeholder="Select Sub Category"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      v-model="ticket.subCategory"
                      :reduce="(subCategory) => subCategory.subCategory"
                      class="min-w-200 w-full mb-2"
                    />
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("entity.label.assign_to")
                      }}<span class="required"> *</span></small
                    >
                    <v-select
                      label="userName"
                      :options="ticketTemplates.usersData"
                      placeholder="--Select One--"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      v-model="ticket.assignedTo"
                      :reduce="(userName) => userName.id"
                      class="min-w-200 w-full mb-2"
                    />
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("entity.label.source")
                      }}<span class="required"> *</span></small
                    >
                    <v-select
                      label="mCodeValue"
                      :options="ticketTemplates.sourceData"
                      placeholder="Select Source"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                      :reduce="(mCodeValue) => mCodeValue.mCodeValue"
                      v-model="ticket.sourceOfTicket"
                    />
                  </div>
                </div>
                <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("Due Time")
                      }}<span class="required"> *</span></small
                    >
                    <flat-pickr
                      :config="configdateTimePicker"
                      class="w-full"
                      v-model="ticket.dueTime"
                    />
                  </div>
                </div>
                <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
                  <vs-input
                    :label="$t('entity.label.title')"
                    v-model="ticket.title"
                    class="w-full font-semibold mb-2 starlabel"
                    icon-no-border
                    :danger="false"
                    danger-text="wrong input"
                  />
                </div>
                <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("entity.label.description")
                      }}<span class="required"> *</span></small
                    >
                    <vs-textarea class="w-full" v-model="ticket.description" />
                  </div>
                </div>
                <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
                  <pick-file @fileUpdate="changeDocument" />
                </div>
              </div>
              <div style="height: 30px"></div>
              <div class="center">
                <span class="ml-1 mr-1">
                  <vs-button
                    @click="addTicket"
                    class="footerButton-next"
                    style="top: 0px"
                    >{{ $t("entity.label.submit") }}</vs-button
                  >
                </span>
              </div>
              <div style="height: 20px"></div>
            </form>
          </vs-popup>
        </div>
        <div class="centerx">
          <vs-popup
            classContent="popup-example"
            :title="$t('entity.label.create_adjustment')"
            :active.sync="AdjustmentPopup"
            class="popup-close"
          >
            <ValidationObserver ref="adjustmentObserver">
              <form>
                <div class="vx-row">
                  <div class="vx-col md:w-1/2 w-full">
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("entity.label.adjustment_date")
                        }}<span class="required"> *</span></small
                      >
                      <datepicker
                        placeholder="Select Date"
                        v-model="adjustment.adjustmentDate"
                        class="mb-2 font-semibold"
                      />
                    </div>
                  </div>
                  <div class="vx-col md:w-1/2 w-full">
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("entity.label.adjustment_code")
                        }}<span class="required"> *</span></small
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="adjustment code"
                        :key="resetKey"
                      >
                        <v-select
                          label="adjustmentCode"
                          v-model="adjustment.adjustmentCode"
                          :options="adjustmentTemplates.data"
                          placeholder="Select One"
                          :reduce="(adjustmentCode) => adjustmentCode.id"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          class="min-w-200 w-full mb-2"
                        />
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col md:w-1/2 w-full">
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="adjustment amount"
                      :key="resetKey"
                    >
                      <vs-input
                        :label="$t('entity.label.adjustment_amount')"
                        type="text"
                        class="w-full font-semibold mb-2 starlabel"
                        v-model="adjustment.adjustmentAmount"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full">
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("entity.label.adjustment_type")
                        }}<span class="required"> *</span></small
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="adjustment type"
                        :key="resetKey"
                      >
                        <v-select
                          label="discountType"
                          :options="adjustmentTemplates.discountOptions"
                          placeholder="Select One"
                          v-model="adjustment.adjustmentType"
                          :reduce="(discountType) => discountType.discountType"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          class="min-w-200 w-full mb-2"
                        />
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col sm:w-1/2 w-1/2">
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("entity.label.notes")
                        }}<span class="required"> *</span></small
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="notes"
                        :key="resetKey"
                      >
                        <vs-textarea
                          class="w-full mb-2"
                          v-model="adjustment.notes"
                        />
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div style="height: 20px"></div>
                <div class="center">
                  <span class="ml-1 mr-1">
                    <vs-button
                      @click="addAdjustment"
                      class="footerButton-next"
                      style="top: 0px"
                      >{{ $t("entity.label.submit") }}</vs-button
                    >
                  </span>
                </div>
                <div style="height: 40px"></div>
              </form>
            </ValidationObserver>
          </vs-popup>
        </div>
        <div class="centerx">
          <vs-popup
            classContent="popup-example"
            :title="$t('entity.label.Create_Payment')"
            :active.sync="paymentsPopup"
            class="popup-close"
          >
            <ValidationObserver ref="paymentObserver">
              <form>
                <div class="vx-row">
                  <div class="vx-col md:w-1/2 w-full">
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("entity.label.collection_by")
                        }}<span class="required"> *</span></small
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="collection by"
                        :key="resetKey"
                      >
                        <vue-simple-suggest
                          v-model="loc"
                          :list="locList"
                          @input="testMethod2"
                          :filter-by-query="true"
                          class="w-full font-normal mb-2"
                        >
                          <div
                            slot="suggestion-item"
                            slot-scope="{ suggestion }"
                          >
                            <span
                              >
                              {{ suggestion.name }}</span
                            >
                          </div>
                          <!-- Filter by input text to only show the matching results -->
                        </vue-simple-suggest>
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="vx-col sm:w-1/2 w-full">
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("entity.label.payment_date")
                        }}<span class="required"> *</span></small
                      >
                      <datepicker
                        name="start-date"
                        class="mb-2"
                        v-model="payment.paymentDate"
                      ></datepicker>
                    </div>
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col sm:w-1/2 w-full">
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("entity.label.payment_type")
                        }}<span class="required"> *</span></small
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="payment type"
                        :key="resetKey"
                      >
                        <v-select
                          label="mCodeValue"
                          v-model="payment.paymentType"
                          :options="paymentTemplate.data"
                          placeholder="Select One"
                          @input="checkCheque(payment.paymentType)"
                          :reduce="(mCodeValue) => mCodeValue.id"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          class="min-w-200 w-full mb-2"
                        />
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="vx-col sm:w-1/2 w-full">
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="amount"
                      :key="resetKey"
                    >
                      <vs-input
                        :label="$t('entity.label.amount')"
                        type="text"
                        class="w-full font-semibold mb-2 starlabel"
                        v-model="payment.amount"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-row" v-if="payment.isChequeSelected">
                  <div class="vx-col sm:w-1/2 w-full">
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="cheque no"
                      :key="resetKey"
                    >
                      <vs-input
                        :label="$t('entity.label.chequeno')"
                        type="text"
                        class="w-full font-semibold mb-2 starlabel"
                        v-model="payment.chequeNo"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col sm:w-1/2 w-full">
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="bank name"
                      :key="resetKey"
                    >
                      <vs-input
                        :label="$t('entity.label.bank_name')"
                        type="text"
                        class="w-full font-semibold mb-2 starlabel"
                        v-model="payment.bankName"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div style="height: 20px" v-if="payment.isChequeSelected"></div>
                <div class="vx-row" v-if="payment.isChequeSelected">
                  <div class="vx-col sm:w-1/2 w-full">
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="branch name"
                      :key="resetKey"
                    >
                      <vs-input
                        :label="$t('entity.label.branch_name')"
                        type="text"
                        class="w-full font-semibold mb-2 starlabel"
                        v-model="payment.branchName"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col sm:w-1/2 w-full"></div>
                </div>
                <div style="height: 20px" v-if="payment.isChequeSelected"></div>
                <div class="vx-row">
                  <div class="vx-col sm:w-1/2 w-full">
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="receipt no"
                      :key="resetKey"
                    >
                      <vs-input
                        :label="$t('entity.label.receipt_no')"
                        type="text"
                        class="w-full font-semibold mb-2 starlabel"
                        v-model="payment.receiptNo"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                    <div style="height: 20px"></div>
                    <vs-checkbox v-model="payment.isWallet" class="mb-2">{{
                      $t("entity.label.is_wallet")
                    }}</vs-checkbox>
                    <div style="height: 20px"></div>
                  </div>
                  <div class="vx-col sm:w-1/2 w-full">
                    <div class="dropdown-with-label">
                      <small class="font-semibold date-label"
                        >{{ $t("entity.label.notes")
                        }}<span class="required"> *</span></small
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="collection by"
                        :key="resetKey"
                      >
                        <vs-textarea
                          class="w-full mb-2"
                          v-model="payment.notes"
                        />
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <!--  -->

                <div class="center">
                  <span class="ml-1 mr-1">
                    <vs-button
                      @click="addPayment"
                      class="footerButton-next"
                      style="top: 0px"
                      >{{ $t("entity.label.submit") }}</vs-button
                    >
                  </span>
                </div>
                <div style="height: 40px"></div>
              </form>
            </ValidationObserver>
          </vs-popup>
        </div>
        <!-- <div class="centerx">
          <vs-popup
            classContent="popup-example"
            :title="$t('label.partneragreement')"
            :active.sync="AgreementPopup"
            class="popup-close"
          >
            <form>
              <div class="vx-row">
                <div class="vx-col sm:w-full w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label">{{
                      $t("entity.label.contreffectdate")
                    }}</small>
                    <datepicker
                      placeholder="Select Date"
                      v-model="agreement.effectDate"
                      class="mb-2 font-semibold"
                    />
                  </div>
                </div>
                <div class="vx-col sm:w-full w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label">{{
                      $t("Contract End Date")
                    }}</small>
                    <datepicker
                      placeholder="Select Date"
                      v-model="agreement.endDate"
                      class="mb-2 font-semibold"
                    />
                  </div>
                </div>
                <div class="vx-col sm:w-full w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label">{{
                      $t("entity.label.agreementstatus")
                    }}</small>
                    <v-select
                      label="mCodeValue"
                      :options="agreementTemplate.agreementTypes"
                      placeholder="Select One"
                      :reduce="(mCodeValue) => mCodeValue.id"
                      v-model="agreement.agreementStatus"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                    />
                  </div>
                </div>
                <div class="vx-col sm:w-full w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label">{{ $t("Agreement Type") }}</small>
                    <v-select
                      label="mCodeValue"
                      :options="FieldType"
                      v-model="agreement.agreementType"
                      placeholder="Select One"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                    />
                  </div>
                </div>
                <div class="vx-col sm:w-full w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label">{{ $t("Plan Type") }}</small>
                    <v-select
                      label="mCodeValue"
                      :options="agreementTemplate.sourceData"
                      v-model="agreement.planCode"
                      :reduce="(mCodeValue) => mCodeValue.id"
                      placeholder="Select One"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                    />
                  </div>
                </div>
              </div>

              <div class="center">
                <span class="ml-1 mr-1">
                  <vs-button class="footerButton-next" style="top: 0px">{{
                    $t("entity.label.save")
                  }}</vs-button>
                </span>
              </div>
              <div style="height: 40px"></div>
            </form>
          </vs-popup>
        </div> -->
        <div class="centerx">
          <vs-popup
            class="popup-close"
            :title="$t('entity.label.PartnerAgreement')"
            :active.sync="AgreementPopup"
          >
            <ValidationObserver ref="AgreementObserver">
              <form>
                <div class="vx-row">
                  <div class="vx-col sm:w-full w-full">
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("entity.label.ContractEffectDate")
                        }}<span class="required"> *</span></small
                      >
                      <datepicker
                        placeholder="Select Date"
                        v-model="agreement.effectDate"
                        class="mb-2 font-semibold"
                      />
                    </div>
                  </div>
                  <div class="vx-col sm:w-full w-full">
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("entity.label.AdjustmentDate")
                        }}<span class="required"> *</span></small
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="adjustment date"
                        :key="resetKey"
                      >
                        <datepicker
                          placeholder="Select Date"
                          v-model="agreement.endDate"
                          class="mb-2 font-semibold"
                        />
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="vx-col sm:w-full w-full">
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("entity.label.AgreementStatus")
                        }}<span class="required"> *</span></small
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="agreement status"
                        :key="resetKey"
                      >
                        <v-select
                          label="mCodeValue"
                          :options="agreementTemplate.agreementTypes"
                          placeholder="Select One"
                          :reduce="(obj) => obj.mCodeValue"
                          v-model="agreement.agreementStatus"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          class="min-w-200 w-full mb-2"
                        />
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="vx-col sm:w-full w-full">
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("entity.label.AgreementType")
                        }}<span class="required"> *</span></small
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="agreement type"
                        :key="resetKey"
                      >
                        <v-select
                          label="mCodeValue"
                          :options="agreementTypeOptions"
                          v-model="agreement.planCode"
                          :reduce="(obj) => obj.mCodeValue"
                          placeholder="Select One"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          class="min-w-200 w-full mb-2"
                        />
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div
                  v-if="
                    agreement.planCode == 'Dealer' ||
                    agreement.planCode == 'Partner'
                  "
                >
                  <h3>{{ $t("entity.label.Commission") }}</h3>
                  <div class="vx-row">
                    <div class="vx-col sm:w-full lg:w-1/2">
                      <div class="dropdown-with-label">
                        <small class="date-label">{{
                          $t("entity.label.CommissionType")
                        }}</small>
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          name="commission type"
                          :key="resetKey"
                        >
                          <v-select
                            label="label"
                            :options="commisionOptions"
                            v-model="commissionType"
                            :reduce="(obj) => obj.value"
                            placeholder="Select One"
                            :dir="$vs.rtl ? 'rtl' : 'ltr'"
                            class="min-w-200 w-full mb-2"
                          />
                          <span class="validate-error" style="color: red">{{
                            errors[0]
                          }}</span>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="vx-col sm:w-full lg:w-1/2">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="value"
                        :key="resetKey"
                      >
                        <vs-input
                          :label="$t('entity.label.Value')"
                          type="number"
                          :max="100"
                          class="w-full font-semibold mb-2 starlabel"
                          v-model="commissionValue"
                        />
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div class="center mt-4">
                  <span class="ml-1 mr-1" v-if="showConfigureBtn">
                    <vs-button
                      @click="initConfigure"
                      class="footerButton-next mb-3"
                      style="top: 0px; width: 400px"
                      >Configure {{ agreement.planCode }} Agreement</vs-button
                    >
                  </span>
                  <span v-else class="ml-1 mr-1">
                    <vs-button
                      @click="createAgreement"
                      class="footerButton-next"
                      style="top: 0px"
                      >{{ $t("entity.label.submit") }}</vs-button
                    >
                  </span>
                </div>
                <div style="height: 20px"></div>
              </form>
            </ValidationObserver>
          </vs-popup>
        </div>
      </div>
    </div>

    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('entity.label.configure')"
        :active.sync="AgreementConfugurePopup"
        class="popup-close"
      >
        <div class="vx-row">
          <div class="vx-col sm:w-full w-full lg:w-1/2">
            <div class="dropdown-with-label">
              <small class="date-label">{{ $t("entity.label.Type") }}</small>
              <v-select
                label="text"
                :options="configureTypeOptions"
                v-model="config.type"
                :reduce="(obj) => obj.value"
                placeholder="Select One"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full"
              />
            </div>
          </div>
          <div
            class="vx-col sm:w-full w-full lg:w-1/2"
            v-if="agreement.planCode == 'Roaming'"
          >
            <div class="dropdown-with-label">
              <small class="date-label">{{
                $t("entity.label.TAPVersion")
              }}</small>
              <v-select
                label="text"
                :options="tapVersionOptions"
                v-model="config.tapVersion"
                :reduce="(obj) => obj.value"
                placeholder="Select One"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full"
              />
            </div>
          </div>
        </div>
        <div class="vx-row" v-if="agreement.planCode == 'Roaming'">
          <div class="vx-col sm:w-full w-full lg:w-1/2">
            <vs-input
              :label="$t('entity.label.TAPInSequence')"
              type="text"
              class="w-full font-semibold mb-2 starlabel"
              v-model="config.tapInSequence"
            />
          </div>
          <div class="vx-col sm:w-full w-full lg:w-1/2">
            <vs-input
              :label="$t('entity.label.TAPOutSequence')"
              type="text"
              class="w-full font-semibold mb-2 starlabel"
              v-model="config.tapOutSequence"
            />
          </div>
        </div>
        <div class="vx-row" v-if="agreement.planCode == 'Roaming'">
          <div class="vx-col sm:w-full w-full lg:w-1/2">
            <vs-input
              :label="$t('entity.label.RAPInSequence')"
              type="text"
              class="w-full font-semibold mb-2 starlabel"
              v-model="config.rapInSequence"
            />
          </div>
          <div class="vx-col sm:w-full w-full lg:w-1/2">
            <vs-input
              :label="$t('entity.label.RAPOutSequence')"
              type="text"
              class="w-full font-semibold mb-2 starlabel"
              v-model="config.rapOutSequence"
            />
          </div>
        </div>
        <div class="vx-row" v-if="agreement.planCode == 'Roaming'">
          <div class="vx-col sm:w-full w-full lg:w-1/2">
            <vs-input
              :label="$t('entity.label.NRTRDEInSequence')"
              type="text"
              class="w-full font-semibold mb-2 starlabel"
              v-model="config.nrtInSequence"
            />
          </div>
          <div class="vx-col sm:w-full w-full lg:w-1/2">
            <vs-input
              :label="$t('entity.label.NRTRDEOutSequence')"
              type="text"
              class="w-full font-semibold mb-2 starlabel"
              v-model="config.nrtOutSequence"
            />
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-full w-full lg:w-1/2">
            <div class="dropdown-with-label">
              <small class="date-label"
                >In
                {{ agreement.planCode == "Roaming" ? "Roaming" : "Settlement" }}
                Plan<span class="required"> *</span></small
              >
              <v-select
                label="planDesc"
                :options="ReportsData.PlanpriceDatas"
                v-model="config.inRoamingPlan"
                placeholder="--Select One--"
                :reduce="(obj) => obj.priceId"
                @input="planName"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full mt-1 mb-2"
              >
              </v-select>
            </div>
          </div>
          <div class="vx-col sm:w-full w-full lg:w-1/2">
            <div class="dropdown-with-label">
              <small class="date-label"
                >Out
                {{ agreement.planCode == "Roaming" ? "Roaming" : "Settlement" }}
                Plan<span class="required"> *</span></small
              >
              <v-select
                label="planDesc"
                :options="ReportsData.PlanpriceDatas"
                v-model="config.outRoamingPlan"
                :reduce="(obj) => obj.priceId"
                placeholder="--Select One--"
                @input="planName"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full mt-1 mb-2"
              >
              </v-select>
            </div>
          </div>
        </div>
        <div class="center mt-4 mb-4">
          <span class="ml-1 mr-1">
            <vs-button
              @click="closeConfigurePopup"
              class="footerButton-next"
              style="top: 0px"
              >{{ $t("entity.label.Cancel") }}</vs-button
            >
          </span>
          <span class="ml-1 mr-1">
            <vs-button
              @click="handleConfigure"
              class="footerButton-next"
              style="top: 0px"
              >{{ $t("entity.label.submit") }}</vs-button
            >
          </span>
        </div>
      </vs-popup>
    </div>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>

<script>
// import HorizonalBtn from "@/layouts/components/HorizontalBtn.vue";

import moment from "moment";
// import _ from "lodash";
import AgreementDetails from "./agreement-detail/Index";
import Tickets from "./tickets/Index";
import Disbursements from "./disbursements/Index";
import Transactions from "./transactions/Index";
import Customers from "./customers/Index";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Datepicker from "vuejs-datepicker";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import { setHeader, removeHeader } from "@/http";
import FeatherIcon from "@/components/FeatherIcon.vue";
import { mapState } from "vuex";
import PickFile from "@/components/PickFile.vue";
const ticketObj = {
  dueTime: null,
  assignedTo: null,
  priority: null,
  sourceOfTicket: null,
  problemCode: null,
  subCategory: null,
  description: null,
  title: "",
  type: "Office",
  locale: "en",
  dateFormat: "dd MMMM yyyy",
  ticketDate: null,
  ticketURL: "https://smartway.trigital.in/app/#/viewTicket/10",
  ticketURL2: "https://ngb.trigital.in/NGB_Client/app/#/viewTicket/",
  ticketTime: null,
};
const adjustmentObj = {
  adjustmentDate: moment().format("DD MMMM YYYY"),
  adjustmentCode: "",
  adjustmentAmount: "",
  discountType: "",
  notes: "",
};
const agreementObj = {
  effectDate: null,
  endDate: null,
  agreementStatus: "",
  planCode: "",
};
const configObj = {
  type: "",
  tapVersion: "",
  tapInSequence: "",
  tapOutSequence: "",
  rapInSequence: "",
  rapOutSequence: "",
  nrtInSequence: "",
  nrtOutSequence: "",
  inRoamingPlan: "",
  outRoamingPlan: "",
};
export default {
  data() {
    return {
      navigationSelection: this.$t("entity.label.business_entity_info"),
      commisionOptions: [
        {
          label: "Percent",
          value: "Percent",
        },
        {
          label: "flat",
          value: "flat",
        },
      ],
      commissionValue: 0,
      resetKey: 0,
      commissionType: "",
      agreementTypeOptions: [
        {
          id: 1,
          mCodeValue: "Roaming",
        },
        {
          id: 2,
          mCodeValue: "Interconnect",
        },
        {
          id: 3,
          mCodeValue: "Dealer",
        },
        {
          id: 4,
          mCodeValue: "Partner",
        },
      ],
      agreementDetails: [],
      config: configObj,
      curAgreementId: "",
      configArr: [],
      configureTypeOptions: [
        { text: "Incoming", value: "Incoming" },
        { text: "Outgoing", value: "Outgoing" },
      ],
      tapVersionOptions: [
        { text: "3.10", value: "3.10" },
        { text: "3.11", value: "3.11" },
        { text: "3.12", value: "3.12" },
      ],
      loc: "",
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      datetime: null,
      descriptionItems: [5, 10, 15],
      user_data: null,
      user_not_found: false,
      activeTab: 0,
      ticketPopup: false,
      ticketPopupEdit: false,
      ticket: ticketObj,
      adjustment: adjustmentObj,
      agreement: agreementObj,
      paymentsPopup: false,
      AdjustmentPopup: false,
      AgreementPopup: false,
      AgreementConfugurePopup: false,
      basicToggle: true,
      agreementToggle: false,
      TicketToggle: false,
      disbursmentToggle: false,
      transactionToggle: false,
      customerToggle: false,
      settlementToggle: false,
      entityId: null,
      paymentType: "",
      configdateTimePicker: {
        enableTime: true,
        dateFormat: "d-m-Y H:i",
      },
      FieldType: [
        "Roaming Agreement",
        "Interconnect Agreement",
        "Dealer",
        "Partner",
        "Roaming Partner ",
        "Interconnect Partner",
      ],

      payment: {
        collectionby: "",
        paymentDate: moment().format("DD MMMM YYYY"),
        paymentType: "",
        amount: "",
        receiptNo: "",
        isWallet: false,
        isChequeSelected: false,
        bankName: "",
        branchName: "",
        chequeNo: "",
        notes: "",
        collectionId: "",
        collectionName: "",
      },
      bulkUploads: {
        file: null,
      },
      paymenttype: [],
      teamUserOptions: [],
      planOptions: [],
      plan: [],
    };
  },
  components: {
    // HorizonalBtn,
    AgreementDetails,
    Tickets,
    Disbursements,
    Customers,
    Transactions,
    VuePerfectScrollbar,
    Datepicker,
    flatPickr,
    "v-select": vSelect,
    VueSimpleSuggest,
    FeatherIcon,
    ValidationProvider,
    ValidationObserver,
    PickFile,
  },
  computed: {
    ...mapState({
      ticketCreated: (state) => state.entity.createTicketResponse,
      partnerAgreementCreated: (state) => state.entity.createAgreementResponse,
      subCategoryItem: (state) => state.entity.ticketSubcategory,
      locList: (state) => state.entity.locationList,
      formattedDate: (state) => state.settings.selectedDateFormat,
      ReportsData: (state) => state.usageRating.GetUsageTemplate,
    }),
    showConfigureBtn() {
      if (
        this.agreement.planCode.toLowerCase() == "roaming" ||
        this.agreement.planCode.toLowerCase() == "interconnect"
      ) {
        return true;
      } else return false;
    },
    entityDetail() {
      return this.$store.getters["entity/getEntityDetail"];
    },
    ticketTemplates() {
      return this.$store.getters["entity/getTicketTemplate"];
    },
    adjustmentTemplates() {
      return this.$store.getters["entity/getAdjustmentsTemplate"];
    },
    agreementTemplate() {
      return this.$store.getters["entity/getAgreementsTemplate"];
    },
    paymentTemplate() {
      return this.$store.getters["entity/getPaymentsTemplate"];
    },
  },
  methods: {
    checkCheque(id) {
      for (let temp of this.paymentTemplate.data) {
        if (temp.id == id) {
          if (temp.mCodeValue === "Cheque") {
            this.payment.isChequeSelected = true;
          } else this.payment.isChequeSelected = false;
        }
      }
    },
    tabNameShort(name) {
      return name.length > 16 ? name.slice(0, 16) + "..." : name;
    },
    handleAddTicket() {
      this.resetKey++;
      this.ticketPopup = true;
    },
    handleCreatePayment() {
      this.resetKey++;
      this.paymentsPopup = true;
    },
    handleAdjustments() {
      this.resetKey++;
      this.AdjustmentPopup = true;
    },
    handleAgreement() {
      this.resetKey++;
      this.AgreementPopup = true;
    },

    togglePage(val) {
      switch (val) {
        case 1: {
          this.basicToggle = true;
          this.agreementToggle = false;
          this.TicketToggle = false;
          this.disbursmentToggle = false;
          this.transactionToggle = false;
          this.customerToggle = false;
          this.settlementToggle = false;
          this.navigationSelection = this.$t(
            "entity.label.business_entity_info"
          );
          break;
        }
        case 2: {
          this.basicToggle = false;
          this.agreementToggle = true;
          this.TicketToggle = false;
          this.disbursmentToggle = false;
          this.transactionToggle = false;
          this.customerToggle = false;
          this.settlementToggle = false;
          this.navigationSelection = this.$t("entity.label.agreement_details");
          break;
        }
        case 3: {
          this.basicToggle = false;
          this.agreementToggle = false;
          this.TicketToggle = true;
          this.disbursmentToggle = false;
          this.transactionToggle = false;
          this.customerToggle = false;
          this.settlementToggle = false;
          this.navigationSelection = this.$t("entity.label.tickets");
          break;
        }
        case 4: {
          this.basicToggle = false;
          this.agreementToggle = false;
          this.TicketToggle = false;
          this.disbursmentToggle = true;
          this.transactionToggle = false;
          this.customerToggle = false;
          this.settlementToggle = false;
          this.navigationSelection = this.$t(
            "entity.label.business_entity_disbursements"
          );
          break;
        }
        case 5: {
          this.basicToggle = false;
          this.agreementToggle = false;
          this.TicketToggle = false;
          this.disbursmentToggle = false;
          this.transactionToggle = true;
          this.customerToggle = false;
          this.settlementToggle = false;
          this.navigationSelection = this.$t(
            "entity.label.financial_transactions"
          );
          break;
        }
        case 6: {
          this.basicToggle = false;
          this.agreementToggle = false;
          this.TicketToggle = false;
          this.disbursmentToggle = false;
          this.transactionToggle = false;
          this.customerToggle = true;
          this.settlementToggle = false;
          this.navigationSelection = this.$t("entity.label.customers");
          break;
        }
        case 7: {
          this.basicToggle = false;
          this.agreementToggle = false;
          this.TicketToggle = false;
          this.disbursmentToggle = false;
          this.transactionToggle = false;
          this.customerToggle = false;
          this.settlementToggle = true;
          this.navigationSelection = this.$t("entity.label.settlement");
          break;
        }
        default: {
          this.basicToggle = true;
          this.agreementToggle = false;
          this.TicketToggle = false;
          this.disbursmentToggle = false;
          this.transactionToggle = false;
          this.customerToggle = false;
          this.settlementToggle = false;
          this.navigationSelection = this.$t(
            "entity.label.business_entity_info"
          );
        }
      }
    },
    changeDocument() {
      this.bulkUploads.file = document.getElementById("file").files[0];
    },
    testMethod2() {
      let temp = this.loc;
      if (temp.includes("{")) {
        temp = JSON.parse(temp);
        if (typeof temp === "object") {
          this.loc = temp.name;
          this.payment.collectionId = temp.id;
          this.payment.collectionName = temp.name;
        }
      } else {
        this.locSuggestionList();
      }
    },

    async locSuggestionList() {
      // this.payment.collectionId = e.id;
      // this.payment.collectionName = e.name;
      try {
        await this.$store.dispatch("entity/entityGetLocationAction", this.loc);

        return this.locList;
      } catch (e) {
        //
      }
    },
    async getEntity() {
      try {
        this.$store.dispatch("entity/setEntityDetail", this.entityId);
      } catch (error) {
        //
      }
    },
    editEntity(id) {
      this.$router.push(`/businessEntity/edit_entity/${id}`);
      // this.$router.push({ name: "Edit Entity", params: { id: id } });
    },
    getDate(date) {
      if (date) {
        return moment(date).format(this.formattedDate);
      }
      return null;
    },
    cancel() {
      this.AdjustmentPopup = false;
    },
    async ticketTemplate() {
      try {
        this.$store.dispatch("entity/setTicketTemplate");
      } catch (error) {
        //
      }
    },
    async adjustmentTemplate() {
      try {
        this.$store.dispatch("entity/setAdjustmentsTemplate");
      } catch (e) {
        //
      }
    },
    async paymentsTemplate() {
      try {
        this.$store.dispatch("entity/setPaymentsTemplate");
      } catch (e) {
        //
      }
    },
    async addPayment() {
      const isValid = await this.$refs.paymentObserver.validate();
      if (!isValid) return;

      try {
        const paymentsObj = {
          paymentCode: this.payment.paymentType,
          amountPaid: this.payment.amount,
          receiptNo: this.payment.receiptNo,
          isWallet: this.payment.isWallet,
          remarks: this.payment.notes,
          locale: "en",
          dateFormat: "dd MMMM yyyy",
          paymentDate: this.payment.paymentDate,
          officePoId: null,
          collectionBy: this.payment.collectionId,
          collectorName: this.payment.collectionName,
        };
        if (this.payment.isChequeSelected) {
          paymentsObj.isChequeSelected = true;
          paymentsObj.chequeNo = this.payment.chequeNo;
          paymentsObj.bankName = this.payment.bankName;
          paymentsObj.branchName = this.payment.branchName;
        }

        await this.$store.dispatch("entity/createPaymentAction", {
          id: this.entityId,
          data: paymentsObj,
        });
        this.paymentsPopup = false;
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Payment Done Successfully!",
          type: "success",
        });
        this.getEntity();
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },

    async addAdjustment() {
      const isValid = await this.$refs.adjustmentObserver.validate();
      if (!isValid) return;

      try {
        const adjustmentObj = {
          adjustmentCode: this.adjustment.adjustmentCode,
          amountPaid: this.adjustment.adjustmentAmount,
          adjustmentType: this.adjustment.adjustmentType,
          remarks: this.adjustment.notes,
          officePoId: null,
          locale: "en",
          dateFormat: "dd MMMM yyyy",
          adjustmentDate: this.adjustment.adjustmentDate,
        };
        await this.$store.dispatch("entity/createAdjustmentAction", {
          id: this.entityId,
          data: adjustmentObj,
        });
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Adjustment Done Successfully!",
          type: "success",
        });
        this.cancel();
        this.getEntity();
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    async agreementsTemplate() {
      try {
        this.$store.dispatch("entity/setAgreementsTemplate");
      } catch (e) {
        //
      }
    },
    async getSubCategory(categoryId) {
      try {
        this.$store.dispatch("entity/setTicketSubcategory", categoryId);
      } catch (e) {
        //
      }
    },
    async addTicket() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      try {
        const ticketObj = {
          priority: this.ticket.priority,
          sourceOfTicket: this.ticket.sourceOfTicket,
          problemCode: this.ticket.problemCode,
          assignedTo: this.ticket.assignedTo,
          title: this.ticket.title,
          description: this.ticket.description,
          subCategory: this.ticket.subCategory,
          locale: "en",
          dateFormat: "dd MMMM yyyy",
          ticketDate: this.ticket.ticketDate,
          ticketURL: `${this.ticket.ticketURL2}${this.entityId}`,
          ticketTime: " " + this.ticket.ticketTime,
          type: this.ticket.type,
        };
        // ticketURL: `https://smartway.trigital.in/app/#/viewTicket/${this.entityId}`,
        let formData = new FormData();
        setHeader("Content-Type", "multipart/form-data");
        formData.append("name", this.ticket.title);
        formData.append("description", this.ticket.description);
        formData.append("file", this.bulkUploads.file);

        removeHeader("Content-Type");

        await this.$store.dispatch("entity/createTicketAction", {
          id: this.entityId,
          data: ticketObj,
        });

        if (this.ticketCreated) {
          formData.append("childEntityId", this.ticketCreated);
          this.$store.dispatch("entity/createTicketDocAction", {
            id: this.entityId,
            data: formData,
          });

          this.ticketPopup = false;
          this.$swal({
            title: "Success",
            icon: "success",
            text: "Ticket Created Successfully!",
            type: "success",
          });
          this.cancel();
        }
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    changeCollection(e) {
      this.payment.collectionId = e.id;
      this.payment.collectionName = e.name;
    },
    async createAgreement() {
      const isValid = await this.$refs.AgreementObserver.validate();
      if (!isValid) return;

      try {
        const agreementPostObj = {
          officeId: this.$route.params.id,
          agreementStatus: this.agreement.agreementStatus,
          agreementType: this.agreement.planCode,
          startDate: moment(this.agreement.effectDate).format("DD MMMM YYYY"),
          endDate: moment(this.agreement.endDate).format("DD MMMM YYYY"),
          dateFormat: "dd MMMM yyyy",
          locale: "en",
          commisionType: this.commissionType,
          value: this.commissionValue,
        };
        // this.agreementDetails = this.agreementDetails.filter(
        //   (el) => el.id !== this.curAgreementId
        // );
        // this.agreementDetails.push({
        //   ...agreementPostObj,
        //   id: this.curAgreementId,
        // });
        // this.config = configObj;
        // this.curAgreementId = "";
        await this.$store.dispatch(
          "entity/createAgreementAction",
          agreementPostObj
        );

        this.AgreementPopup = false;
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Agreement Created Successfully!",
          type: "success",
        });
        this.createAgreementResetForm();
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    createAgreementResetForm() {
      this.agreement = agreementObj;
      this.agreement.agreementStatus = "";
      this.agreement.planCode = "";
      this.agreement.endDate = "";
      this.commissionValue = "";
      this.commissionType = "";
    },
    closeConfigurePopup() {
      this.AgreementConfugurePopup = false;
      this.AgreementPopup = true;
    },
    initConfigure() {
      this.curAgreementId = Date.now() + Math.random();
      this.AgreementPopup = false;
      this.AgreementConfugurePopup = true;
    },
    async handleConfigure() {
      this.AgreementConfugurePopup = false;
      this.AgreementPopup = false;
      let obj = {
        officeId: this.$route.params.id,
        agreementStatus: this.agreement.agreementStatus,
        agreementType: this.agreement.planCode,
        startDate: moment(this.agreement.effectDate).format("DD MMMM YYYY"),
        endDate: moment(this.agreement.endDate).format("DD MMMM YYYY"),
        dateFormat: "dd MMMM yyyy",
        locale: "en",
        type: this.config.type,
        insettlementPlan: this.config.inRoamingPlan,
        outsettlementPlan: this.config.outRoamingPlan,
      };
      // this.configArr.push(obj);
      // this.AgreementConfugurePopup = false;
      // this.AgreementPopup = true;
      // this.config = configObj;
      try {
        await this.$store.dispatch("entity/createAgreementAction", obj);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Agreement Created Successfully!",
          type: "success",
        });
        this.handleConfigureResetForm();
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage;
        this.$swal({
          title: "Error",
          icon: "error",
          text: this.errorMessage,
          type: "error",
        });
      }
    },
    handleConfigureResetForm() {
      this.config = configObj;
      this.config.type = "";
      this.config.tapVersion = "";
      this.config.tapInSequence = "";
      this.config.tapOutSequence = "";
      this.config.rapInSequence = "";
      this.config.rapOutSequence = "";
      this.config.nrtInSequence = "";
      this.config.nrtOutSequence = "";
      this.config.inRoamingPlan = "";
      this.config.outRoamingPlan = "";
      this.agreement.endDate = "";
      this.agreement.agreementStatus = "";
      this.agreement.planCode = "";
    },
  },
  async mounted() {
    this.entityId = this.$route.params.id;
    await this.$store.dispatch("entity/setAgreementsTemplate");
    await this.$store.dispatch("usageRating/setUsageTemplate");
    this.getEntity();

    this.agreementsTemplate();
  },
  watch: {
    ticketPopup(newValue) {
      if (newValue) {
        this.ticketTemplate();
        this.ticket.ticketDate = moment().format("DD MMMM YYYY");
        this.ticket.ticketTime = moment().format("hh:mm:ss A");
      } else {
        this.ticket = {
          dueTime: null,
          assignedTo: null,
          priority: null,
          sourceOfTicket: null,
          problemCode: null,
          subCategory: null,
          description: null,
          title: "",
          type: "Office",
          locale: "en",
          dateFormat: "dd MMMM yyyy",
          ticketDate: null,
          ticketURL: "https://smartway.trigital.in/app/#/viewTicket/10",
          ticketURL2: "https://ngb.trigital.in/NGB_Client/app/#/viewTicket/",
          ticketTime: null,
        };
      }
    },
    AdjustmentPopup(newValue) {
      if (newValue) {
        this.adjustmentTemplate();
        this.adjustment.adjustmentDate = moment().format("DD MMMM YYYY");
      } else {
        this.adjustment = {
          adjustmentDate: moment().format("DD MMMM YYYY"),
          adjustmentCode: "",
          adjustmentAmount: "",
          discountType: "",
          notes: "",
        };
      }
    },
    AgreementPopup(newValue) {
      if (newValue) {
        this.agreementsTemplate();
        this.agreement.effectDate = moment().format("DD MMMM YYYY");
      } else {
        //
      }
    },
    paymentsPopup(newValue) {
      if (newValue) {
        this.paymentsTemplate();
      } else {
        this.payment = {
          collectionby: "",
          paymentDate: moment().format("DD MMMM YYYY"),
          paymentType: "",
          amount: "",
          receiptNo: "",
          isWallet: false,
          isChequeSelected: false,
          bankName: "",
          branchName: "",
          chequeNo: "",
          notes: "",
          collectionId: "",
          collectionName: "",
        };
      }
    },
    "ticket.problemCode"(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getSubCategory(this.ticket.problemCode);
      }
    },
  },
};
</script>

<style lang="scss">
v-select {
  --vs-border-color: #f22 !important;
}

#page-user-view {
  .service-order-tbl {
    td {
      min-width: 102px !important;
    }
  }
}
.popup-example {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}
.customer-tab {
  .vs-tabs--content {
    // max-height: 27rem !important;
    // overflow-y: auto;
    // overflow-x: hidden;
    padding-top: 10px;
    &:hover {
      overflow-y: auto;
      transition: 0.2s;
      transition-delay: 0.2s;
    }
  }
}
#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }
}
.vs-tabs--content::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: transparent;
}

.vs-tabs--content::-webkit-scrollbar {
  width: 4px;
}

.vs-tabs--content::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #7367f0;
}
.edit-btn {
  position: absolute;
  width: 10px;
  border-radius: 50% !important;
  top: 4px;
  right: 4px;
}
.nav-heading {
  position: absolute;
  left: 23%;
  font-size: 21px;
  font-weight: 500;
}
.liveactive {
  &::after {
    content: "\A";
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #00ce00;
    display: inline-block;
  }
}
.vs-sidebar {
  z-index: 9999999;
}
#parentx {
  overflow: hidden;
  height: 500px;
  position: relative;
}
#sidebars-customizer .vs-sidebar {
  max-width: 360px !important;
}
.vs-sidebar .vs-sidebar--items {
  overflow-y: auto;
  overflow-x: hidden;
}
.vs-sidebar--items::-webkit-scrollbar {
  width: 0px;
  background: transparent !important;
}
.header-right-sidebar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  h4 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    > button {
      margin-left: 10px;
    }
  }
}

.footer-sidebar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  > button {
    border: 0px solid rgba(0, 0, 0, 0) !important;
    border-left: 1px solid rgba(0, 0, 0, 0.07) !important;
    border-radius: 0px !important;
  }
}
.flatpickr-calendar.open {
  z-index: 999999999999;
}
[dir="ltr"] .nav-heading {
  left: 2%;
}
[dir] .vx-row > .vx-col {
  padding: 0px 0.3rem 0px 1rem;
}
</style>
